import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Aux from '../../../components/Hoc/Aux';
import DocSearch from '../../../components/DocSearch/DocSearch.jsx';
import ReasonsMedicaid from '../../../components/Reasons/ReasonsMedicaid';

class Medicaid extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'visitorType': 'Prospect - Medicaid',
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Medicaid',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        <ReasonsMedicaid classes='divider p60' headline='true' medicaid='true' />
        <DocSearch search='https://findadoc.cdphp.com/?PlanType=Medicaid - Select Plan' />
        <section className='divide p60'>
          <div className='wrap'>
            <h2>Find out if you qualify.</h2>
            <ul className='inline'>
              <li><Link to='/medicaid/find-a-plan/zip?skip=true' className='btn alt'>For Just Me</Link></li>
              <li><Link to='/medicaid/family/find-a-plan' params={{ family: 'hello' }} className='btn alt'>For My Family</Link></li>
            </ul>
          </div>
        </section>
      </Aux>
    );
  }
}

Medicaid.propTypes = { // validate props expected
};

export default Medicaid;
